'use client';

import React, { useMemo } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';
export default function StyledComponentsRegistry({
  children
}: {
  children: React.ReactNode;
}) {
  // Only create stylesheet once with lazy initial state
  // x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
  const sheet = useMemo(() => new ServerStyleSheet(), []);
  useServerInsertedHTML(() => {
    const styles = sheet.getStyleElement();
    sheet.instance.clearTag();
    return <>{styles}</>;
  });
  if (typeof window !== 'undefined') return <>{children}</>;
  return <StyleSheetManager sheet={sheet.instance} data-sentry-element="StyleSheetManager" data-sentry-component="StyledComponentsRegistry" data-sentry-source-file="StyledComponentsRegistry.tsx">{children}</StyleSheetManager>;
}